/**
 * マニフェスト管理 紐付け保守
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'
import { BigNumber } from 'bignumber.js';
import {
  DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_CLEAR_ITEM,
} from "@/store/mutation-types/driver-types";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/previouslies`

const getDefaultState = () => {
  return {
    selectedItems: [],
  }
}

const manifest_previously = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    quantityTotal: ( state ) => {
      return state.quantityTotal
    },
    selectedMembers: (state) => {
      return state.selectedItems
    }
  },
 actions: {
    /**
     * マニフェスト一覧
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 検索結果の選択状態のクリア
     * @param commit
     */
    clearIndividualItem ({ commit }) {
      commit(DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_CLEAR_ITEM)
    },
    /**
     * 個別登録
     * @param commit
     * @param item
     */
    setIndividualItem ({ commit }, { item }) {
      commit(types.DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_SET_ITEM, { item })
    },
    /**
     * 個別削除
     * @param commit
     * @param item
     */
    removeIndividualItem ({ commit }, { item }) {
      commit(types.DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_REMOVE_ITEM, { item })
    },
    removeItem({ commit }, { item }) {
      commit(types.DRIVER_MANIFEST_PREVIOUSLY_REMOVE_ITEM, { item })
    },
    allRemoveItems({ commit }) {
      commit(types.DRIVER_MANIFEST_PREVIOUSLY_ALL_REMOVE_ITEMS)
    },
  },

  mutations: {
    /**
     * 検索結果の選択状態のクリア
     * @param state
     */
    [types.DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_CLEAR_ITEM] (state) {
      state.selectedItems = []
    },
    /**
     * 個別, 一括でチェックされた際に
     * @param state
     * @param item
     */
    [types.DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_SET_ITEM] (state, { item }) {
      if (state.selectedItems.includes(item.id))
        return

      const quantityTotal = (state.quantityTotal)
      const total = BigNumber(quantityTotal).plus(item.quantity)
      state.quantityTotal = total <= 0 ? 0 : total

      state.selectedItems.push(item.id)
      state.individualItems.push(item.id)
    },
    /**
     * 一括でチェックを外す
     * @param state
     * @param item
     */
    [types.DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_REMOVE_ITEM] (state, { item }) {
      state.selectedItems = state.selectedItems.filter(v => v !== item.id)
      state.individualItems = state.individualItems.filter(v => v !== item.id)
      const quantityTotal = (state.quantityTotal)
      const total = BigNumber(quantityTotal).minus(item.quantity)
      state.quantityTotal = total <= 0 ? 0 : total

    },
    /**
     * 個別でチェックを外す
     * @param state
     * @param id
     */
    [types.DRIVER_MANIFEST_PREVIOUSLY_REMOVE_ITEM] (state, { item }) {
      if (state.selectedItems.includes(item.id)) {
        state.selectedItems = state.selectedItems.filter(v => v !== item.id)
        state.individualItems = state.individualItems.filter(v => v !== item.id)
        if (!state.individualItems.includes(item.id)) {
          const quantityTotal = (state.quantityTotal)
          const total = BigNumber(quantityTotal).minus(item.quantity)
          state.quantityTotal = total <= 0 ? 0 : total
        }
      }
    },
    /**
     * チェックボックス設定(全部チェック無にする)
     * @param state
     */
    [types.DRIVER_MANIFEST_PREVIOUSLY_ALL_REMOVE_ITEMS] (state) {
      state.selectedItems = null
      state.individualItems = null
      state.selectedItems = []
      state.individualItems = []
      state.checkedTargetResults = []
      state.quantityTotal = 0
    },
  },

}

export default manifest_previously
